module.exports = __webpack_public_path__ + "img/24.dd041bb3.png";